import ShareRow from "../../../../src/tailwindComponents/ShareRow";
import * as React from 'react';
export default {
  ShareRow,
  React
};